import React, { useState } from 'react';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  LogoIcon,
  LogoText,
  NavItems,
  NavLink,
  ButtonContainer,
  ContactNavButton,
  MobileIcon,
  MobileMenu,
  MobileLink,
} from './NavbarStyledComponent';
import { DiCssdeck } from 'react-icons/di';
import { FaBars, FaTimes } from 'react-icons/fa';
import { FiSend } from 'react-icons/fi';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Nav>
      <NavbarContainer>
        {/* LOGO */}
        <NavLogo to="/">
          <LogoIcon>
            <DiCssdeck size="2.4rem" />
          </LogoIcon>
          <LogoText>
            Ravi<span>/Singh</span>
          </LogoText>
        </NavLogo>

        {/* DESKTOP NAV LINKS */}
        <NavItems>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#services">Services</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
          <NavLink href="#contact">Contact</NavLink>
        </NavItems>

        {/* RIGHT ACTION BUTTON */}
        <ButtonContainer>
          <ContactNavButton href="#contact">
            <FiSend /> Let's Talk
          </ContactNavButton>
        </ButtonContainer>

        {/* MOBILE TOGGLE ICON */}
        <MobileIcon onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </MobileIcon>

        {/* MOBILE MENU */}
        <MobileMenu isOpen={isOpen}>
          <MobileLink href="#about" onClick={() => setIsOpen(false)}>
            About
          </MobileLink>
          <MobileLink href="#services" onClick={() => setIsOpen(false)}>
            Services
          </MobileLink>
          <MobileLink href="#skills" onClick={() => setIsOpen(false)}>
            Skills
          </MobileLink>
          <MobileLink href="#experience" onClick={() => setIsOpen(false)}>
            Experience
          </MobileLink>
          <MobileLink href="#projects" onClick={() => setIsOpen(false)}>
            Projects
          </MobileLink>
          <MobileLink href="#education" onClick={() => setIsOpen(false)}>
            Education
          </MobileLink>
          <MobileLink href="#contact" onClick={() => setIsOpen(false)}>
            Contact
          </MobileLink>
          <ContactNavButton
            href="#contact"
            onClick={() => setIsOpen(false)}
            style={{ width: '100%', justifyContent: 'center', padding: '12px' }}
          >
            <FiSend /> Let's Talk
          </ContactNavButton>
        </MobileMenu>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;